import { IChannelHistoryParams, IChannelHistoryEntity } from '../../../entity/interface/iChannelSeriesHistory';
import { IChannelSeriesHistoryRepository } from '../../repositories/interfaces/iChannelSeriesHistoryRepository';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
export interface IGetChannelHistoryUseCase {
    execute(
        apiKey: string,
        profileName: string,
        paylod: IChannelHistoryParams,
        token: string,
        identityToken: string
    ): Promise<IChannelHistoryEntity[]>;
}
class GetChannelHistoryUseCase implements IGetChannelHistoryUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelSeriesHisRepo(): IChannelSeriesHistoryRepository {
        return container.resolve<IChannelSeriesHistoryRepository>(DI.REPOSITORIES.IChannelSeriesHistoryRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apiKey: string,
        profileName: string,
        paylod: IChannelHistoryParams,
        token: string,
        identityToken: string
    ): Promise<IChannelHistoryEntity[]> {
        const response = await this.channelSeriesHisRepo.getChannelHistory(
            apiKey,
            profileName,
            paylod,
            token,
            identityToken
        );
        return response?.data?.channels || [];
    }
}

export default GetChannelHistoryUseCase;
